import { EstimateLineItem } from "@/hooks/useEstimateLineItems";

export const REPLACEABLE_CATEGORIES: Record<string, { 
  allowMultiple: boolean; 
  keywords?: string[] 
}> = {
  'Shingles': { allowMultiple: false, keywords: ['shingle', 'timberline', 'architectural', 'dimensional'] },
  'Underlayment': { allowMultiple: false, keywords: ['underlayment', 'felt', 'synthetic'] },
  'Ridge Cap': { allowMultiple: false, keywords: ['ridge', 'cap', 'hip'] },
  'Ice & Water': { allowMultiple: false, keywords: ['ice', 'water', 'shield', 'barrier'] },
  'Starter Strip': { allowMultiple: false, keywords: ['starter', 'strip'] },
  'Drip Edge': { allowMultiple: false, keywords: ['drip', 'edge'] },
  'Ventilation': { allowMultiple: true },
  'Flashing': { allowMultiple: true },
  'Fasteners': { allowMultiple: false, keywords: ['nail', 'fastener', 'coil'] },
  'Labor': { allowMultiple: true },
  'Tear-Off': { allowMultiple: false, keywords: ['tear', 'off', 'removal', 'disposal'] },
  'Plywood': { allowMultiple: false, keywords: ['plywood', 'decking', 'sheathing'] },
};

function matchesCategory(description: string, keywords: string[]): boolean {
  if (!keywords || keywords.length === 0) return false;
  
  const lowerDesc = description.toLowerCase();
  return keywords.some(keyword => lowerDesc.includes(keyword.toLowerCase()));
}

export function shouldReplaceProduct(
  productCategory: string,
  productDescription: string,
  existingLineItems: EstimateLineItem[]
): EstimateLineItem | null {
  const categoryConfig = REPLACEABLE_CATEGORIES[productCategory];
  
  // If category not found or allows multiple items, don't replace
  if (!categoryConfig || categoryConfig.allowMultiple) {
    return null;
  }
  
  // Find existing auto-generated item in this category
  const existingItem = existingLineItems.find(item => {
    // Only replace auto-generated items (from XML)
    if (item.calculation_source !== 'auto') {
      return false;
    }
    
    // Check if the existing item matches this category
    if (categoryConfig.keywords) {
      return matchesCategory(item.description, categoryConfig.keywords);
    }
    
    return false;
  });
  
  return existingItem || null;
}
